export class featureMakeMarkedSelectedFilterDescription {
    private static elements: HTMLDivElement[] = [];

    public static clearSelection() {
        this.elements.forEach(el => {
            let el2 = el.querySelector('.filter-description-item');
            if (el2) {
                el2.classList.remove('active');
            } else {
                console.warn('clearSelection missing element: ', el2);
            }
        });
        this.elements = [];
    }

    public static setActive(div: HTMLDivElement, active: boolean) {
        this.elements.push(div);
        let el = div.querySelector('.filter-description-item');
        if (el) {
            if (active) {
                el.classList.add('active');
            } else {
                el.classList.remove('active');
            }
        }
    }
}
